import { TextSource } from './types';
import { NAV } from '../siteData';

/**
 * Kopf- und Fußzeile — der Rahmen, der auf jeder Seite gleich ist.
 *
 * Die Beschriftungen der Navigation kommen aus `NAV` in `siteData.ts`; der
 * Schlüssel ergibt sich aus dem Ziel (`/kosten` → `navigation.kosten`). Wohin ein
 * Menüpunkt führt, bleibt damit eine Sache des Codes — nur wie er heißt, nicht.
 */
export const RAHMEN: TextSource = {
  ...Object.fromEntries(
    NAV.map((item) => [
      `navigation.${item.to.replace(/^\//, '')}`,
      { text: item.label, max: 30, label: `Menüpunkt „${item.label}"` },
    ]),
  ),
  'navigation.karriere': { text: 'Karriere', max: 30, label: 'Menüpunkt „Karriere" (nur mobil)' },

  'kopf.beratung': { text: 'Kostenlose Beratung', max: 30 },

  'fuss.beschreibung':
    'Ihre regionale Seniorenbetreuung aus Gifhorn — zuverlässig, einfühlsam und individuell.',
  'fuss.leistungen.titel': { text: 'Leistungen', max: 26 },
  'fuss.leistungen.24h': { text: '24H Betreuung', max: 30 },
  'fuss.leistungen.hauswirtschaft': { text: 'Hauswirtschaft', max: 30 },
  'fuss.leistungen.kosten': { text: 'Kosten', max: 30 },
  'fuss.unternehmen.titel': { text: 'Unternehmen', max: 26 },
  'fuss.unternehmen.ueber-uns': { text: 'Über uns', max: 30 },
  'fuss.unternehmen.karriere': { text: 'Karriere', max: 30 },
  'fuss.unternehmen.aktuelles': { text: 'Aktuelles', max: 30 },
  'fuss.unternehmen.kontakt': { text: 'Kontakt', max: 30 },
  'fuss.einsatzgebiet.titel': { text: '24h-Betreuung vor Ort', max: 30 },
  'fuss.rechtliches.titel': { text: 'Rechtliches', max: 26 },
  'fuss.rechtliches.datenschutz': { text: 'Datenschutz', max: 30 },
  'fuss.rechtliches.partner': { text: 'Partner', max: 30 },
  'fuss.rechtliches.impressum': { text: 'Impressum', max: 30 },
  // `{jahr}` setzt das laufende Jahr ein — die Angabe altert damit nicht.
  'fuss.copyright': '© 2017–{jahr} Seniorenbetreuung Antczak. Alle Rechte vorbehalten.',
  'fuss.login': { text: 'Mitarbeiter-Login', max: 30 },
};

export default RAHMEN;
